// extracted by mini-css-extract-plugin
export default {"swiperbtn":"SwipeBtn_swiperbtn__ffo9c","activeClassName":"SwipeBtn_activeClassName__FWckM"};